import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Loading from "../Components/Loading";
import { isDataPopulated } from "../utils";

export const WithFetchJsonContent = ({
  reduxInStore,
  addToReduxFunction,
  jsonLocation,
  showLoading = true,
  children,
}) => {
  const dispatch = useDispatch();
  const hasAnyData = isDataPopulated(reduxInStore);
  const [hasData, setHasData] = useState(hasAnyData);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const fetchJson = async () => {
      if (!reduxInStore || Object.keys(reduxInStore).length === 0) {
        try {
          const res = await fetch(`/json/${jsonLocation}.json`, { signal: controller.signal });
          if (!res.ok) throw new Error(`HTTP error, status = ${res.status}`);
          const contentType = res.headers.get("content-type");
          // Only add data if it's json, this prevents bugs and console errors
          if (contentType && contentType.includes("application/json")) {
            const data = await res.json();
            if (isMounted) dispatch(addToReduxFunction(data));
          }
        } catch (err) {
          if (isMounted) console.error(err);
        } finally {
          if (isMounted) setHasData(true);
        }
      } else {
        setHasData(true);
      }
    };

    fetchJson();

    return () => {
      isMounted = false;
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fallbackComponent = showLoading ? <Loading /> : null;

  return hasData ? children : fallbackComponent;
};
